/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).on('shopify:section:load', function (e) {
    $('.logoList--carousel').flickity({
        prevNextButtons: false,
        wrapAround: true,
        dragThreshold: 16,
        pageDots: false,
        autoPlay: 3000,
        watchCSS: true
    });

    // $('.Doorways').flickity();

    $('.ticker').each(function () {
        var tickerSpeed = $(this).data('speed');
        var tickerDirection = $(this).data('direction');

        $(this).webTicker({
            speed: tickerSpeed,
            direction: tickerDirection,
            startEmpty: false,
            duplicate: true,
            height: "100px"
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
let accountMenu = $('.PageLayout__Section-sidebar');

var getLastPartOfUrl =function($url) {
    var url = $url;
    var urlsplit = url.split("/");
    var lastpart = urlsplit[urlsplit.length-1];
    if(lastpart==='')
    {
        lastpart = urlsplit[urlsplit.length-2];
    }
    return lastpart;
}

let path = getLastPartOfUrl(location.href);
if (path == 'account#orders') {
    $('ul.PageLayout__Section-sidebar li').removeClass('is-order')
    $('ul.PageLayout__Section-sidebar [data-id="/account#orders"]').addClass('is-order');
    $('ul.PageLayout__Section-sidebar li a').removeClass('is-active');
    $('ul.PageLayout__Section-sidebar [data-id="/account#orders"] a').addClass('is-active');
    $('div#orders').addClass('is-active');
    $('div#account').removeClass('is-active');
  
}

if (location.href.indexOf('account#orders') > -1) {
    $('ul.PageLayout__Section-sidebar li').removeClass('is-order')
    $('ul.PageLayout__Section-sidebar [data-id="/account#orders"]').addClass('is-order');
    $('ul.PageLayout__Section-sidebar li a').removeClass('is-active');
    $('ul.PageLayout__Section-sidebar [data-id="/account#orders"] a').addClass('is-active');
    accountMenu.removeClass('show-full');
}

if ($(window).width() < 769) {
  $('ul.PageLayout__Section-sidebar .is-order a').attr('href','#');
  $('.PageLayout__Section-sidebar .is-order a').click(function(e){
     $('.PageLayout__Section-sidebar li a').removeClass('is-active');
      e.preventDefault();
      accountMenu.toggleClass('show-full');
      $(this).parent().attr('data-id','');
      $(this).addClass('is-active');
      $('.PageLayout__Section-sidebar .is-order a').attr('href','#');
  })
}

$('.PageLayout__Section-sidebar [data-id="/account#orders"]').click(function(e){
  // e.preventDefault();
  accountMenu.toggleClass('show-full');
  $('ul.PageLayout__Section-sidebar li').removeClass('is-order')
  $('ul.PageLayout__Section-sidebar [data-id="/account#orders"]').addClass('is-order');
  $('ul.PageLayout__Section-sidebar li a').removeClass('is-active');
  $('ul.PageLayout__Section-sidebar [data-id="/account#orders"] a').addClass('is-active');
  $('div#orders').addClass('is-active');
  $('div#account').removeClass('is-active');
})


if (window.innerWidth < 769) {
    let aboutMenu = document.querySelector('.Page-Sidebar');
    if (aboutMenu != null) {
    var element = document.querySelector(".Custom_Page");
    element.insertBefore(aboutMenu, element.firstChild);
    let itemActive = aboutMenu.querySelector('li.Linklist__Item.order-active-item');
      itemActive.addEventListener('click',function() {
          aboutMenu.querySelector('ul').classList.toggle('show-full');
      });
      }
    }
});

$(document).ready(function () {
    $(document).on('click', '[data-action="toggle-tab"]', function (e) {
        e.preventDefault();

        var parentTabs = $(this).closest('.Section_Tabs');
        var TabPanel = parentTabs.find('.TabPanel');
        var TabList__Item = parentTabs.find('.TabList [data-action="toggle-tab"]');

        if ($(this).hasClass('is-active') === false) {
            TabList__Item.removeClass('is-active');
            TabPanel.attr('aria-hidden', 'true');
            
          if (window.innerWidth > 1006 ) {
            var Carousel = $('#' + $(this).attr('aria-controls')).find('.Carousel');
            var flkty = Carousel.data('flickity-config');
            Carousel.flickity(flkty);
            setTimeout(function () {
                Carousel.flickity('resize');
                equals_height();
            }, 200);
           
          }
          $(this).addClass('is-active');
          $('#' + $(this).attr('aria-controls')).attr('aria-hidden', 'false');
        } else {
            return;
        }

        $('.template-product .Section_recently-viewed-products .SectionHeader').hide();
    });

    $('.ProductSlide--2rows').each(function () {
        $(this).slick({
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            rows: 2,
            infinite: true,
            arrows: true,
            prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg viewBox="0 0 240.823 240.823"><path fill="currentColor" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z"/></svg></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-next"><svg viewBox="0 0 240.823 240.823"><path fill="currentColor" d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179   l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261   C187.881,124.315,187.881,116.495,183.189,111.816z"/></svg></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
    });

    $(document).on('click', '.ProductItem .ProductForm__Option [data-action="select_variant"]', function (e) {
        e.preventDefault();
        console.log('hihi');
        $(this).closest('.ProductForm').find('.Select_variant').slideToggle();
    });

    $(document).on('click', '.ProductItem .ProductForm__Option [data-action="trigger_select"]', function (e) {
        e.preventDefault();

        $(this).closest('.ProductForm').find('.Select_variant').slideUp();
        var variant_id = $(this).data('value');
        var FormSelect = $(this).closest('.ProductForm').find('select');
        FormSelect.find('option').removeAttr('selected');
        FormSelect.find('option[value = "' + variant_id + '"]').prop("selected", true);
        FormSelect.trigger('change');

        $(this).closest('.ProductForm').find('[data-action="ajax-add-to-cart"]').trigger('click');
    });

    $(document).on('click', '[data-action="ajax-add-to-cart"]', function (e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        var addToCartButton = $(this);

        // First, we switch the status of the button
        addToCartButton.attr('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        var QuickForm = $(this).closest('form[action="/cart/add"]');

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: QuickForm.serialize(),
            dataType: 'json',
            success: function (result) {
                addToCartButton.removeAttr('disabled');
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
                document.dispatchEvent(new CustomEvent('theme:loading:end'));

                if (QuickForm.hasClass('ProductForm__DrawerCart__Upsell') === false) {
                    const cartIcon = document.querySelector('.Header__SecondaryNav a[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
                    cartIcon.click();
                }

            },
            error: function (error) {
                addToCartButton.removeAttribute('disabled');
                $("<span class='ProductForm__Error Alert Alert--error'>" + error.responseJSON.description + "</span>").insertAfter(addToCartButton);
                setTimeout(function () {
                    $('.ProductForm__Error').remove();
                }, 2500);

                document.dispatchEvent(new CustomEvent('theme:loading:end'));
            }
        });
    });

    $(document).on('click', '[data-accordion-trigger]', function (e) {
        e.preventDefault();

        var parentCollapsible = $(this).closest('.Footer__Block');
        var collapsibleInner = parentCollapsible.find('[data-accordion-content]');

        if ($(this).attr('aria-expanded') === 'false') {

            $('[data-accordion-trigger]').attr('aria-expanded', 'false');
            $('[data-accordion-content]').slideUp();

            $(this).attr('aria-expanded', 'true');
            collapsibleInner.slideDown();

        } else {
            $(this).attr('aria-expanded', 'false');
            collapsibleInner.slideUp();
        }
    });

    $(document).on('click', '[data-action="open-SubSidebarMenu"]', function (e) {
        e.preventDefault();

        var parent = $(this).closest('.SidebarMenu__Nav-link');
        var SubSidebarMenu = parent.find('.SubSidebarMenu');
        var title = $(this).data('title');
        $('.Drawer__Title').text(title);
        $('.SubSidebarMenu__Close').attr('aria-hidden', 'false');

        SubSidebarMenu.addClass('show');
    });

    $(document).on('click', '[data-action="close-SubSidebarMenu"]', function (e) {
        e.preventDefault();

        $('.SubSidebarMenu').removeClass('show');
        $('.Drawer__Title').text('Menu');
        $(this).attr('aria-hidden', 'true');
    });

    $(document).on('click', '.SidebarMenu [data-action="close-drawer"]', function (e) {
        e.preventDefault();

        $('.SubSidebarMenu').removeClass('show');
        $('.SidebarMenu .Drawer__Title').text('Menu');
        $('[data-action="close-SubSidebarMenu"]').attr('aria-hidden', 'true');
    });

    $(document).on('click', '.PageOverlay', function (e) {
        e.preventDefault();

        $('.SubSidebarMenu').removeClass('show');
        $('.SidebarMenu .Drawer__Title').text('Menu');
        $('[data-action="close-SubSidebarMenu"]').attr('aria-hidden', 'true');
    });

    $(document).on('click', '[data-action="open_Brands_List"]', function (e) {
        e.preventDefault();

        if ($(this).attr('aria-expanded') === 'false') {
            $(this).attr('aria-expanded', 'true');
            $('.Brands_List').slideDown();
        } else {
            $(this).attr('aria-expanded', 'false');
            $('.Brands_List').slideUp();
        }
    });

    $('.section--overflow').on('click', '.readMore-btn', function (e) {
        e.preventDefault();

        $(this).closest('.section--overflow').toggleClass('in');

        if ($(this).closest('.section--overflow').hasClass('in')) {
            $(this).html('<span>Read less</span>');
        } else {
            $(this).html('<span>Read more</span>');
        }
    });

    $(document).on('click', '[data-action="open-dropdown-sort"]', function () {
        var parentSort = $(this).closest('.CollectionToolbar');
        var SortInner = parentSort.find('.CollectionSort_Dropdown');
        var filterInner = parentSort.find('.CollectionFilters_Dropdown');

        if ($(this).attr('aria-expanded') === 'false') {
            $(this).attr('aria-expanded', 'true');
            SortInner.slideDown();
            filterInner.slideUp();
            parentSort.find('[data-action="open-dropdown-filter"]').attr('aria-expanded', 'false');
        } else {
            $(this).attr('aria-expanded', 'false');
            SortInner.slideUp();
        }
    });

    $(document).on('click', '[data-action="open-dropdown-filter"]', function () {
        var parentFilter = $(this).closest('.CollectionToolbar');
        var filterInner = parentFilter.find('.CollectionFilters_Dropdown');
        var SortInner = parentFilter.find('.CollectionSort_Dropdown');

        if ($(this).attr('aria-expanded') === 'false') {
            $(this).attr('aria-expanded', 'true');
            filterInner.slideDown();
            SortInner.slideUp();
            parentFilter.find('[data-action="open-dropdown-sort"]').attr('aria-expanded', 'false');
        } else {
            $(this).attr('aria-expanded', 'false');
            filterInner.slideUp();
        }
    });

    $(document).on('click', '[data-action="close-dropdown"]', function () {
        var parentFilter = $(this).closest('.CollectionFilters_Dropdown');
        
        parentFilter.slideUp();
        $('[data-action="open-dropdown-filter"]').attr('aria-expanded', 'false');
    });

    $(document).on('click', '[data-action="trigger-clear"]', function () {
        var parentFilter = $(this).closest('.CollectionFilters_Dropdown');

        parentFilter.find('.boost-pfs-filter-clear-all').trigger('click');
    });


    // if (window.innerWidth < 769) {
      $(document).on('click', '.boost-pfs-filter-button', function () {
        // var parentFilter = $(this).closest('.CollectionFilters_Dropdown');

        // parentFilter.slideUp();
        $('[data-action="close-dropdown"]').trigger('click');
        // $('[data-action="open-dropdown-filter"]').attr('aria-expanded', 'false');
        $('[data-action="close-drawer"][data-drawer-id="collection-filter-drawer"]').trigger('click');
      });
    // }

    $(document).on('mouseleave', '.Header__Nav', function (e) {
        $(this).removeClass('hover');

        $('.Header__Nav .is-expanded').each(function () {
            $(this).removeClass('is-expanded');
        });

        $('.Header__MainNav [aria-hidden="false"]').each(function () {
            $(this).attr('aria-hidden', 'true');
        });
    });

    $(document).on('click', '[data-action="open-drawer-checkout"]', function (e) {
        e.preventDefault();

        $('.Drawer [data-action="close-drawer"]').trigger('click');

        var data = $(this).attr('data-drawer-id');

        if ($('html').hasClass('no-scroll') === false) {
            $('html').addClass('no-scroll');
        }
        if ($('.PageOverlay').hasClass('is-visible') === false) {
            $('.PageOverlay').addClass('is-visible');
        }
        $('#' + data).attr('aria-hidden', 'false');
        $('#' + data).focus();
    });

    $(document).on('click', '.CheckoutLogin [data-action="close-drawer"]', function (e) {
        e.preventDefault();

        var data = $(this).attr('data-drawer-id');
        $('#' + data).attr('aria-hidden', 'true');
        $('html').removeClass('no-scroll');
        $('.PageOverlay').removeClass('is-visible');
    });

    /*==================================================== */

    var back_to_top = $('.CTA_backToTop');

    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            back_to_top.addClass('show');
        } else {
            back_to_top.removeClass('show');
        }
    });

    back_to_top.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, '300');
    });


    /*==================================================== */

    //WEBTICKER
    $('.ticker').each(function () {
        var tickerSpeed = $(this).data('speed');
        var tickerDirection = $(this).data('direction');

        $(this).webTicker({
            speed: tickerSpeed,
            direction: tickerDirection,
            startEmpty: false,
            duplicate: true,
            height: "100px"
        });
    });

    /*==================================================== */

    if ($('body').hasClass('template-article')) {
        var ProductList = $('.Article__Body [data-replace]');
        if (ProductList) {
            $('.Article__Body .ProductListWrapper').replaceWith(ProductList);
        }
    }

    /*==================================================== */

    if ($('body').hasClass('template-collection')) {
        setTimeout(function () {
            var heightDescription = $('.template-collection .section--overflow .section-container').innerHeight();

            if (heightDescription < 130) {
                $('.template-collection .section--overflow .section-actions').hide();
            }
            else {
                $('.template-collection .section--overflow .section-actions').show();
            }
        }, 300);
    }
  	if ($('body').hasClass('template-product')) {
      var heightDescription = $('.Product--des .section--overflow .section-container .text').innerHeight();

      if (heightDescription < 200) {
        $('.Product--des .section--overflow .section-actions').hide();
      }
      else {
        $('.Product--des .section--overflow .section-actions').show();
      }
    }

    /*==================================================== */

    if ($('body').hasClass('template-product')) {
        ProductPage();
    }

    /*==================================================== */

    if ($('body').hasClass('template-account')) {
        var recently_viewed_products = $('.template-account #shopify-section-recently-viewed-products');
        var Section_featured_collections = $('.template-account .Section_featured-collections');
        setTimeout(function () {
            if (!recently_viewed_products.is(':visible')) {
                Section_featured_collections.show();
            } else {
                Section_featured_collections.hide();
            }
        }, 500);
    }

    addReview();
    equals_height();

    $(window).on('load resize', function () {
        equals_height();
    });

    $(window).on('scroll resize', function () {
    });

    
    $('#block-MoreFromThisBrand .ProductList--carousel').flickity({
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        contain: true,
        cellAlign: "center",
        watchCSS: true,
        dragThreshold: 8,
        groupCells: true,
        arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
    });
});

function addReview() {
    if (typeof sswRun == "function") {
        sswRun(function () {
            var waitForContainer = setInterval(function () {
                if (ssw('.boost-pfs-filter-products .Grid__Cell').length) {
                    function addWidgets() {
                        window.ssw_widgets_products = [];
                        ssw('.boost-pfs-filter-products .Grid__Cell').each(function (index, element) {
                            if (!ssw(element).find(ssw('.ssw-faveicon-custom')).length) {
                                var getUrl = ssw(element).find('.ProductItem__ImageWrapper').attr('href');
                                var sswFaveIcon = `<div class="ssw-faveicon-custom" data-product-id="${getUrl}"></div>`;
                                var sswReviewListing = `<div class="ssw-review-custom" data-product-id="${getUrl}"></div>`;
                                window.ssw_widgets_products.push(getUrl);
                                ssw(element).find('.ProductItem__ImageWrapper ').before(ssw(sswFaveIcon));
                                ssw(element).find(ssw('.ProductItem__PriceList')).after(ssw(sswReviewListing));
                            }
                        });
                        
                        function ssw_widgets(handles) {
                            handles.forEach((handle) => {
                                $.get(handle, { view: 'ssw-metafield' }, function (res) {
                                    let tmp = ssw('<div>', { html: res });
                                    tmp.find('.ssw-faveiticon').each(function (e, i) {
                                        ssw(`.ssw-faveicon-custom[data-product-id="${handle}"]`).html(i);
                                    });
                                    tmp.find('.ssw-widget-avg-rate-listing').each(function (e, i) {
                                        ssw(`.ssw-review-custom[data-product-id="${handle}"]`).html(i);
                                    });
                                });
                            });
                            window.ssw_widgets_products = [];
                        }
                        ssw_widgets(window.ssw_widgets_products);
                    }

                    addWidgets()

                    const observer = new MutationObserver(function (mutations) {
                        for (let mutation of mutations) {
                            if (mutation.type === 'childList') {
                                addWidgets()
                            }
                        }
                    })
                    observer.observe(ssw('.boost-pfs-filter-products').get(0), { childList: true })
                    clearInterval(waitForContainer)
                }
            }, 300);
        });
    }
}


function equals_height() {
    setTimeout(function () {
      $('.equals-height').equalHeights();
      $('.equals-height-product').equalHeights();
      $('.equals-height-product-image').equalHeights();
      $('.equals-height-product-title').equalHeights();
    }, 500);

    setTimeout(function () {
        $('.flickity-slider .equals-height-product').equalHeights();
        $('.flickity-slider .equals-height-product-image').equalHeights();
        $('.flickity-slider .equals-height-product-title').equalHeights();
    }, 1000);
}


function ProductPage() {
    /*==================================================== */

    var variant_selected = $('.template-product .ProductForm select[name="id"] option:selected').data('sku');

    $('.template-product .Product__SlideshowNavImage').each(function () {
        var alt = $(this).data("alt");
        if (alt) {
            if (alt.indexOf(variant_selected) < 0) {
                $(this).hide();
            } else {
                $(this).show();
            }
        }
        
    });

    $('.template-product .Product__SlideshowNavDot').each(function () {
        var alt = $(this).data("alt");
        if (alt) {
            if (alt.indexOf(variant_selected) < 0) {
                $(this).hide();
            } else {
                $(this).show();
            }
        }
    });

    $('.template-product .Product__SlideItem').each(function () {
        var alt = $(this).data("alt");
        var position = $(this).data('media-position') - 1;
        if (alt.indexOf(variant_selected) < 0) {
            $('.Product__SlideshowMobileNav .flickity-page-dots [data-index="' + position + '"]').hide();
        } else {
            $('.Product__SlideshowMobileNav .flickity-page-dots [data-index="' + position + '"]').show();
        }
    });

    $(document).on('click', '.template-product .Product__ChangeImage .ColorSwatch__Radio', function (e) {
        var value = $(this).val();
        $('.template-product .Product__ChangeImage .Color_Selected').text(value);
        $('.template-product .OptionSelector .Popover__Value[data-value="' + value + '"]').trigger('click');
    });

    /*==================================================== */


    $(document).on('click', '.Product__Gallery .Product__SlideshowNavImage', function (e) {
        e.preventDefault();

        var img_id = $(this).attr('href');

        $('.Product__Gallery .Product__SlideshowNavImage').removeClass('is-selected');
        $('.Product__Gallery .Product__SlideItem').removeClass('is-selected');

        $(this).addClass('is-selected');
        $(img_id).addClass('is-selected');
    });

    $(document).on('click', '.Product__Gallery .Product__SlideshowNavDot', function (e) {
        e.preventDefault();

        var img_id = $(this).attr('href');

        $('.Product__Gallery .Product__SlideshowNavDot').removeClass('is-selected');
        $('.Product__Gallery .Product__SlideItem').removeClass('is-selected');

        $(this).addClass('is-selected');
        $(img_id).addClass('is-selected');
    });
   
    /*==================================================== */

    // if ($(window).width() > 1008) {
    //     var heightInfo = $('.Product__Info').innerHeight();
    //     var heightImage = $('.Product__Slideshow').innerHeight();
    //     var heightVariant = $('.Product__ChangeImage').innerHeight();
    //     var heightLeftColumn = heightImage + heightVariant;

    //     if (heightInfo > heightLeftColumn) {
    //         $('.Product').height(heightInfo);
    //     }
    //     else {
    //         $('.Product').height(heightLeftColumn);
    //     }


    //     $('.Product__Tabs .Collapsible__Button').click(function () {
    //         setTimeout(function () {
    //             var heightInfo = $('.Product__Info').innerHeight();
    //             var heightImage = $('.Product__Slideshow').innerHeight();
    //             var heightVariant = $('.Product__ChangeImage').innerHeight();
    //             var heightLeftColumn = heightImage + heightVariant;

    //             if (heightInfo > heightLeftColumn) {
    //                 $('.Product').height(heightInfo);
    //             }
    //             else {
    //                 $('.Product').height(heightLeftColumn);
    //             }
    //         }, 300);
    //     });
    // }
}